import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div
          data-testid="error-boundary"
          className="flex flex-col items-center justify-center py-10 text-center"
        >
          <span
            className="material-symbols-outlined mb-3"
            style={{ fontSize: '40px', color: 'var(--foreground-muted)', opacity: 0.5 }}
            aria-hidden="true"
          >
            error_outline
          </span>
          <p
            className="text-sm font-medium"
            style={{ color: 'var(--foreground)' }}
          >
            Er is een onverwachte fout opgetreden
          </p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            className="mt-4 rounded-lg px-4 py-2 text-[0.8125rem] font-medium"
            style={{
              border: '1px solid var(--border)',
              backgroundColor: 'var(--background)',
              color: 'var(--foreground)',
            }}
          >
            Opnieuw proberen
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
